export default __webpack_public_path__ + "media/images/user/calendar-c12cd87563b71265e73fd64c2bfeaca4.png";